<template>
  <!--Layout for mobile version -->
  <div
    :class="[
      hasKiosk
        ? 'flex pb-4 items-center w-2/3 justify-between mx-auto mt-2'
        : '',
      menu.layout == 'frydate' ? 'uppercase' : ''
    ]"
  >
    <div
      :class="['flex justify-center items-center rounded-full py-4 w-1/2 mr-2']"
      v-if="hasKiosk && processBarIndex == 1"
      @click="
        $modal.hide('cart-items');
        deleteprogress();
      "
      :style="makeStyles(hasKiosk&&secondButtonRadius,goBackButton , goBackButtonText)"
    >
      <p class="text-xl">{{ lang["forgot_something"][this.language] }}</p>
    </div>
    <div
      :class="['flex justify-center items-center rounded-full w-1/2 mr-2']"
      :style="makeStyles(hasKiosk&&secondButtonRadius,goBackButton , goBackButtonText)"
      v-if="hasKiosk && processBarIndex > 1"
      @click="previousProcess"
    >
      <p class="text-xl py-4">
        {{ lang["go_back"][this.language] }}
      </p>
    </div>
    <div
          v-if="processCurrentName != 'Done'"
      :class="[
        updateRouteAndProcess.EnablePossible &&
          theme.floatingCartInfoButton.unabledButtonBrackgroundColor,
        'mx-4 p-2 flex w-54 items-center justify-center rounded-full relative',
        'p-2 flex w-54 items-center justify-center rounded-full ',
        hasKiosk ? 'text-xl w-1/2 ml-2' : 'h-12 md:mb-4 mx-4 ',
        updateRouteAndProcess.EnablePossible
          ? theme.floatingCartInfoButton.unabledButtonBrackgroundColor
          : 'bg-new-primary',
        isCickable,
      ]"
      :style="makeStyles(hasKiosk&&mainButtonRadius, paymentBtnBackground, text)"
      @click="goToTop()"
    >
      <div class="rounded-full bg-white"></div>
      <div
        v-if="
          this.$route.name === 'Category' ||
          this.$route.name === 'CategoryCategory' ||
          this.$route.name === 'CategoryCategory'
        "
        :class="[
          'w-full flex text-white justify-center' /* theme.body.primaryLoaderColor */,
        ]"
      >
        <div
          v-if="processBarIndex == 1"
          @click="
            parseInt(totalPriceValue) + tipAmount < menu.min_spent_amount ||
            parseInt(totalPriceValue) + tipAmount <
              menu.min_spent_amount_delivery
              ? ''
              : updateRouteAndProcess()
          "
          class="w-full text-center py-2 flex items-center justify-center"
          :style="paymentBtnText"
        >
          {{ hasKiosk?lang["payment"][this.language]:lang["confirm_my_order"][this.language] }}
          <span class="ml-1" v-currency="totalPriceValueWithCosts"></span>
        </div>

        <div
          v-else-if="
            processBarIndex == 2 &&
            showTable == false &&
            showPayment == false &&
            showForm == false &&
            showTableManual == false
          "
          @click="selectedTimeSlot ? updateRouteAndProcess() : ''"
          class="w-full text-center py-2 flex items-center justify-center"
          :style="paymentBtnText"
        >
          {{ buttonStack[buttonStack.length - 1] }}
        </div>
        <div
          v-else-if="
            processBarIndex == 2 &&
            showTable == true &&
            showForm == false &&
            showTableManual == false
          "
          @click="tableId > 0 ? updateRouteAndProcess() : ''"
          class="w-full text-center py-2 flex items-center justify-center"
          :style="paymentBtnText"
        >
          {{ buttonStack[buttonStack.length - 1] }}
        </div>
        <div
          v-else-if="
            processBarIndex == 2 &&
            showTableManual == true &&
            showForm == false &&
            showTable == false
          "
          @click="tableManual ? updateRouteAndProcess() : ''"
          class="w-full text-center py-2 flex items-center justify-center"
          :style="paymentBtnText"
        >
          {{ buttonStack[buttonStack.length - 1] }}
        </div>
        <div
          v-else-if="
            (processBarIndex == 2 && showForm) ||
            (processBarIndex == 3 && showPayment == false)
          "
          @click="isCickable == '' ? updateRouteAndProcess() : ''"
          class="w-full text-center py-2 flex items-center justify-center"
          :style="paymentBtnText"
        >
          {{ buttonStack[buttonStack.length - 1] }}
        </div>
        <div
          v-else
          @click="updateRouteAndProcess()"
          class="w-full text-center py-2 flex items-center justify-center"
          :style="paymentBtnText"
        >
          {{ buttonStack[buttonStack.length - 1] }}
        </div>
      </div>
      <div
        v-else
        :class="[
          'w-full flex text-white text-center' /*  + theme.body.primaryLoaderColor */,
        ]"
      >
        {{ computedNextRouteProperties.label }}
      </div>
      <div :class="['border-l-1']"></div>
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      lang: lang,
    };
  },
  computed: {
    ...mapGetters([
      "menuHash",
      "language",
      "menu",
      "theme",
      "processCurrentName",
      "floatButtonLabel",
      "ProcessBarCurrentItem",
      "processBarIndex",
      "buttonStack",
      "showTable",
      "showPayment",
      "showForm",
      "isCickable",
      "hasKiosk",
      "showTableManual",
      "processStack",
    ]),
    ...mapGetters("Cart", [
      "tableId",
      "stickerId",
      "selectedTimeSlot",
      "customer",
      "tipAmount",
      "totalPriceValueWithCosts",
      "totalPriceValue",
      "tableManual",
      "cartItems",
      "redeemLoyaltyPoints"
    ]),
    ...mapGetters("Theme", [
      "text",
      "paymentBtnText",
      "paymentBtnBackground",
      "mainButtonRadius",
      "secondButtonRadius",
      "goBackButton",
      "goBackButtonText",
    ]),
    computedNextRouteProperties() {
      this.$store.commit("updateIsSwipeOpen", false);
      let path = "";
      let label = "";
      if (this.cartItems.length === 0) {
        path = `/${this.menuHash}`;
        label = lang["add_something_to_cart"][this.language];
        this.$store.commit("updateIsCartViewShown", false);

        return {
          path: path,
          label: label,
          labelPosition: "justify-center",
          showIcon: true,
          showItems: false,
        };
      }
      if (
        this.$route.name === "Category" ||
        this.$route.name === "CategoryCategory"
      ) {
        this.$store.commit("updateIsCartViewShown", true);
      } else {
        this.$store.commit("updateIsCartViewShown", false);
      }
      return {
        visibility: false,
      };
    },
  },
  created() {
    window.$eventBus.$on("updateRouteAndProcess", () => {
      this.updateRouteAndProcess();
    })
  },
  beforeDestroy() {
      /** Remove the event listeners */
      window.$eventBus.$off("updateRouteAndProcess");
    },
  methods: {
    //  go back to the previeus step if you click on the arrow button inside the cart modal
    previousProcess() {
      this.$store.commit("updateProcessBarIndex", this.processBarIndex - 1);
      // since the processbar counts per 2 we also delete with 2 to go back
      this.$store.commit(
        "updateProcessBarCurrentItem",
        this.processBarCurrentItem - 2
      );
      this.$store.commit("deleteProcessStack");
      this.$store.commit("deleteButtonStack");
      this.$store.commit("updateShowPayment", false);
      this.$store.commit(
        "updateProcessCurrentName",
        this.processStack[this.processStack.length - 1]
      );
      // To cancel the como payment in the case when user redeems the loyalty points on payment page and returns to the previous page instead of making the payment
      if (this.processCurrentName == 'Payment' && this.redeemLoyaltyPoints == true) {
        this.$store.commit("Cart/updateRedeemLoyaltyPoints", false);
      }
    },
    deleteprogress() {
      this.$store.commit("updateShowPayment", false);
    },
    // go to top of the scroll in the checkout process
    goToTop() {
      document.getElementById("modalCartMobile")?.scrollIntoView();
    },
    updateRouteAndProcess() {
      let path = "";
      let label = "";
      let onClickIndex;
      let routeName;
      let processBarUpdate;
      // this switch case is used to predict the next step into the process
      switch (this.processCurrentName) {
        case "UserDetails": {
          // update the button text to go to the payment
          this.$store.commit(
            "updateFloatButtonLabel",
            lang["continue_to_payment"][this.language]
          );
          this.$store.commit(
            "updateButtonStack",
            lang["continue_to_payment"][this.language]
          );
          // these are checks to update the processbar to the rightindex
          if (
            this.menu.timeslots_mode == "simple" ||
            (this.menu.timeslots_mode == "" && this.menu.pos_mode == "take-out")
          ) {
            this.$store.commit("updateShowForm", true);
            this.$store.commit("updateProcessBarCurrentItem", 3);
            this.$store.commit("updateProcessBarIndex", 2);
          } else {
            this.$store.commit("updateProcessBarCurrentItem", 5);
            this.$store.commit("updateProcessBarIndex", 3);
          }
          this.$store.commit("updateProcessCurrentName", "Payment");
          this.$store.commit("updateProcessStack", "Payment");
          if (
            this.menu.pos_mode != "take-out" &&
            this.stickerId != 0
          ) {
            this.$store.commit("updateShowForm", true);
            this.$store.commit("updateProcessBarCurrentItem", 3);
            this.$store.commit("updateProcessBarIndex", 2);
          }

          return {
            path: path,
            label: label,
            labelPosition: "justify-center",
            showIcon: false,
            showItems: false,
            onClickIndex: onClickIndex,
            routeName: routeName,
            processBarUpdate: processBarUpdate,
          };
        }
        case "TimeSlotSelection": {
          // if we need to select a timeslot we know that we want to show the contact details. So we prepare the button, the index and the stack
          this.$store.commit(
            "updateFloatButtonLabel",
            lang["leave_contact_details"][this.language]
          );
          this.$store.commit(
            "updateButtonStack",
            lang["leave_contact_details"][this.language]
          );
          this.$store.commit("updateProcessCurrentName", "UserDetails");
          this.$store.commit("updateProcessStack", "UserDetails");
          this.$store.commit("updateProcessBarIndex", 2);
          this.$store.commit("updateProcessBarCurrentItem", 3);
          onClickIndex = 3;
          processBarUpdate = 5;

          return {
            path: path,
            label: label,
            labelPosition: "justify-center",
            showIcon: false,
            showItems: false,
            onClickIndex: onClickIndex,
            routeName: routeName,
            processBarUpdate: processBarUpdate,
          };
        }
        case "TableSelection": {
          if (
            this.menu.pos_mode == "table" &&
            this.stickerId == 0
          ) {
            path = this.$route.path;
          }
          // checks if the user needs to fill in the customer detail
          if (this.menu.customer_details_disabled == false && (this.hasKiosk ? this.menu.is_checkout_name_enabled || this.menu.show_phone_number : true)) {
            this.$store.commit(
              "updateFloatButtonLabel",
              lang["leave_contact_details"][this.language]
            );
            this.$store.commit(
              "updateButtonStack",
              lang["leave_contact_details"][this.language]
            );
            this.$store.commit("updateProcessBarCurrentItem", 3);
            this.$store.commit("updateProcessBarIndex", 2);
            this.$store.commit("updateProcessCurrentName", "UserDetails");
            this.$store.commit("updateProcessStack", "UserDetails");
            // checks what table mode option we want to show in the process
            if (this.menu.pos_mode == "table") {
              this.$store.commit("updateShowTable", true);
            } else {
              this.$store.commit("updateShowTableManual", true);
            }
          } else {
            // go to the payment step
            if (
              this.stickerId == 0 ||
              this.tableId == null
            ) {
              this.$store.commit(
                "updateFloatButtonLabel",
                lang["continue_to_payment"][this.language]
              );
              this.$store.commit(
                "updateButtonStack",
                lang["continue_to_payment"][this.language]
              );
              this.$store.commit("updateProcessBarCurrentItem", 3);
              this.$store.commit("updateProcessBarIndex", 2);
              this.$store.commit("updateProcessCurrentName", "Payment");
              this.$store.commit("updateProcessStack", "Payment");
            } else {
              this.$store.commit(
                "updateFloatButtonLabel",
                lang["continue_to_payment"][this.language]
              );
              this.$store.commit(
                "updateButtonStack",
                lang["continue_to_payment"][this.language]
              );
              this.$store.commit("updateProcessBarCurrentItem", 3);
              this.$store.commit("updateProcessBarIndex", 2);
              this.$store.commit("updateShowPayment", true);
              this.$store.commit("updateProcessCurrentName", "Payment");
              this.$store.commit("updateProcessStack", "Payment");
            }
          }
          return {
            path: path,
            label: label,
            labelPosition: "justify-center",
            showIcon: false,
            showItems: false,
          };
        }
        case "Payment":
          {
            // all the steps to go to the payment screen
            if (this.menu.pos_mode != "take-out") {
              if (this.processBarIndex == 3) {
                this.$store.commit("updateProcessBarCurrentItem", 7);
                this.$store.commit("updateProcessBarIndex", 4);
                this.$store.commit("updateProcessCurrentName", "Done");
                this.$store.commit("updateProcessStack", "Payment");
                this.$store.commit(
                  "updateButtonStack",
                  lang["payment"][this.language]
                );
              } else {
                if (this.processBarIndex == 2) {
                  this.$store.commit("updateShowPayment", true);
                  this.$store.commit("updateProcessBarCurrentItem", 5);
                  this.$store.commit("updateProcessBarIndex", 3);
                  this.$store.commit("updateProcessCurrentName", "Done");
                  this.$store.commit("updateProcessStack", "Payment");
                  this.$store.commit(
                    "updateButtonStack",
                    lang["payment"][this.language]
                  );
                } else {
                  this.$store.commit("updateShowTable", false);
                  this.$store.commit("updateShowTableManual", false);
                  this.$store.commit("updateShowPayment", true);
                  this.$store.commit("updateProcessBarCurrentItem", 3);
                  this.$store.commit("updateProcessBarIndex", 2);
                  this.$store.commit("updateProcessCurrentName", "Done");
                  this.$store.commit("updateProcessStack", "Payment");
                  this.$store.commit(
                    "updateButtonStack",
                    lang["payment"][this.language]
                  );
                }
              }
            }
            if (this.menu.pos_mode == "take-out") {
              if (this.processBarIndex == 3) {
                this.$store.commit("updateProcessBarCurrentItem", 7);
                this.$store.commit("updateProcessBarIndex", 4);
                this.$store.commit("updateProcessCurrentName", "Done");
                this.$store.commit("updateProcessStack", "Payment");
                this.$store.commit(
                  "updateButtonStack",
                  lang["payment"][this.language]
                );
                // this.$store.commit("updateProcessCurrentName", "Payment4");
              } 
              else if(this.processBarIndex == 1 && (this.hasKiosk && !this.menu.is_checkout_name_enabled && !this.menu.show_phone_number)) {
                  this.$store.commit("updateShowTable", false);
                  this.$store.commit("updateShowTableManual", false);
                  this.$store.commit("updateShowPayment", true);
                  this.$store.commit("updateProcessBarCurrentItem", 3);
                  this.$store.commit("updateProcessBarIndex", 2);
                  this.$store.commit("updateProcessCurrentName", "Done");
                  this.$store.commit("updateProcessStack", "Payment");
                  this.$store.commit(
                    "updateButtonStack",
                    lang["payment"][this.language]
                  );
              }
              
              else if (this.processBarIndex == 1) {
                this.$store.commit("updateProcessBarCurrentItem", 7);
                this.$store.commit("updateProcessBarIndex", 4);
                this.$store.commit("updateProcessCurrentName", "Done");
                this.$store.commit("updateProcessStack", "Payment");
                this.$store.commit(
                  "updateButtonStack",
                  lang["payment"][this.language]
                );
              } else {
                this.$store.commit("updateShowPayment", true);
                this.$store.commit("updateProcessBarCurrentItem", 5);
                this.$store.commit("updateProcessBarIndex", 3);
                this.$store.commit("updateProcessCurrentName", "Done");
                this.$store.commit("updateProcessStack", "Payment");
                this.$store.commit(
                  "updateButtonStack",
                  lang["payment"][this.language]
                );
              }
            }
          }
          break;
        default:
        // code block
      }
    },
  },
};
</script>
